/* eslint-disable */
/* tslint:disable */
// @ts-nocheck

// This code is auto-generated by Plasmic; please do not edit!
// Plasmic Project: wboCjrKjkicgLwUG7d8r4V

import { createUseGlobalVariants } from "@plasmicapp/react-web";

import { useScreenVariants as useScreenVariantsox6HAsFkEwCv } from "./PlasmicGlobalVariant__Screen"; // plasmic-import: Ox6hAsFkEWCv/globalVariant
import { TmpValue, useTmp } from "./PlasmicGlobalVariant__Tmp"; // plasmic-import: 3bAlhEoWqjIU/globalVariant
import { Tmp2Value, useTmp2 } from "./PlasmicGlobalVariant__Tmp2"; // plasmic-import: BppLMTkT-DDn/globalVariant

export const _useGlobalVariants = createUseGlobalVariants({
  screen: useScreenVariantsox6HAsFkEwCv,
  tmp: useTmp,
  tmp2: useTmp2
});
